module.exports = __webpack_public_path__ + "img/wait.f26abb23.png";